import axios from "axios";
export default {
    saveSummaryReport: (summaryReport) => axios.post("/SummaryReports/SaveSummaryReport", summaryReport),
    getSummaryReport: (summaryReportId) => axios.post("/SummaryReports/GetSummaryReport", { Id: summaryReportId })
};
